<template>
  <div class="search-main">
    <form action="">
      <div class="search-box">
        <input type="text" class="global-search" placeholder="Search products..." v-model="searchTextModel">
        <button class="btn-search" @click.prevent="searchShop"><i class="fa fa-search" aria-hidden="true"></i>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: 'SearchOtherProducts',
  computed: {
    ...mapGetters([
      'searchText'
    ]),
    searchTextModel: {
      get() { return this.searchText },
      set(value) { this.setSearchText(value) }
    }
  },
  methods: {
    ...mapMutations([
      'setSearchText'
    ]),
    ...mapActions([
      'searchShop'
    ])
  }
}
</script>
